// Append the JWT to a /uploads/... URL so the auth-gated static mount serves it.
//
// Why this exists: index.js gates 14 upload dirs (/chat, /kb, /errands, /medical,
// /invoices, …) behind a JWT it accepts from the Authorization header OR a ?token=
// query param. A plain <a href> or <img src> is a browser navigation — it carries
// no header — so an ungated link to a gated dir 401s and the user lands on a
// "authentication required" page instead of their file. Every module that links to
// a gated dir MUST wrap the URL here.
//
// It was copy-pasted into 6 pages and simply missing from the chat, which is how
// every chat attachment ended up undownloadable (reported by Thiago, 24-ago-2026).
export default function authUrl(url) {
  if (!url) return url;
  const token = localStorage.getItem('accessToken');
  return token ? `${url}${url.includes('?') ? '&' : '?'}token=${token}` : url;
}
